import React from 'react'
import { Container as BaseContainer } from '@peracto/peracto-blocks-tailwind'
import ContainerComponent from './Component'
import ContainerForm from './Form'

/**
 * Enhanced Container Block
 * Overrides the form to add custom container size options
 */
const Container = {
    // Use our custom component
    Component: (props) => <ContainerComponent {...props} />,

    // Use our custom form with additional size options
    FormComponent: (props) => <ContainerForm {...props} />,

    // Keep the base metadata and configuration
    name: BaseContainer.name,
    version: BaseContainer.version,
    text: BaseContainer.text,
    description: BaseContainer.description,
    IconComponent: BaseContainer.IconComponent,
    createInitialState: BaseContainer.createInitialState,
    createInitialChildren: BaseContainer.createInitialChildren,
}

export default Container
